import { jsx as a, jsxs as G, Fragment as L } from "react/jsx-runtime";
import { Tooltip as W } from "@strata/react-tooltip";
import { Intent as f, Tag as M, Icon as b } from "@blueprintjs/core";
import D from "classnames";
import "./main.scss";
import { IconNames as j } from "@blueprintjs/icons";
import { DropdownMenu as k } from "@strata/react-dropdown-menu";
import { useState as u, useEffect as w } from "react";
const F = {
  NONE: f.NONE,
  ERROR: f.DANGER,
  WARNING: f.WARNING,
  SUCCESS: f.SUCCESS,
  INFO: f.PRIMARY
}, O = ({
  fill: p,
  leftIcon: s = void 0,
  intent: n = F.NONE,
  interactive: i,
  label: R = void 0,
  multiline: o,
  onClick: C,
  onRemove: r,
  rightIcon: v,
  className: g,
  style: T
}) => /* @__PURE__ */ a(
  M,
  {
    minimal: !0,
    className: D("sds_tag", g),
    fill: p,
    icon: s,
    intent: n,
    interactive: i,
    multiline: o,
    onClick: C,
    onRemove: r && ((N, E) => {
      r(N, E), N.stopPropagation();
    }),
    rightIcon: v,
    style: T,
    children: R
  }
);
O.Intent = F;
const H = ({ lite: p = void 0 }) => p ? /* @__PURE__ */ a(W, { content: "Lite pharmacy", intent: W.Intent.INFO, children: /* @__PURE__ */ a(O, { label: "Lite", intent: O.Intent.INFO }) }) : null, J = ({
  fill: p,
  intent: s = O.Intent.NONE,
  menuItemArray: n,
  selectedItem: i = void 0,
  placeholderText: R = "--",
  onItemSelect: o = void 0,
  disabled: C = !1,
  disableAutoPopulate: r = !1,
  multiline: v,
  className: g,
  style: T
}) => {
  const [N, E] = u(!1), x = !C && (n ?? []).length > 1;
  return w(() => {
    !r && !i && (n ?? []).length > 0 && (o == null || o(n[0]));
  }, [i, n, r, o]), /* @__PURE__ */ a(
    k,
    {
      menuItemArray: n == null ? void 0 : n.filter((h) => h.text !== (i == null ? void 0 : i.text)).map((h) => ({
        ...h,
        onItemClick: () => o == null ? void 0 : o(h)
      })),
      isOpen: N,
      onClose: () => E(!1),
      className: g,
      children: /* @__PURE__ */ a(
        O,
        {
          className: g,
          fill: p,
          leftIcon: i == null ? void 0 : i.icon,
          intent: s,
          interactive: x,
          label: (i == null ? void 0 : i.text) ?? R,
          multiline: v,
          rightIcon: /* @__PURE__ */ G(L, { children: [
            i == null ? void 0 : i.labelElement,
            x && /* @__PURE__ */ a(
              b,
              {
                icon: j.CARET_DOWN,
                size: 12,
                style: { minWidth: 12 },
                className: D("caret", { "caret--up": N })
              }
            )
          ] }),
          onClick: x ? () => E(!0) : void 0,
          style: T
        }
      )
    }
  );
};
export {
  H as LiteSupplierTag,
  O as Tag,
  J as TagWithDropdown
};
//# sourceMappingURL=index.js.map
